// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {

      "nav": {
        "home": "Home",
        "equipments": "Equipments",
        "solutions": "Solutions",
        "solutions.mri": "MRI Shielding",
        "solutions.dental": "Dental",
        "solutions.specialized": "Specialized Solutions",
        "solutions.design": "Complete Project Design",
        "solutions.networking": "Hospital Networking",
        "solutions.icu": "ICU Pendants",
        "business": "Our Business",
        "business.turnkey": "Turnkey Equipping",
        "business.agency": "Agency Sales",
        "business.construction": "Hospital Construction",
        "projects": "Projects"
      },

      ////////////////////////////////////////////
      "hero": {
        "heading": "Empowering Healthcare Through Engineering Excellence",
        "subheading": "We specialize in the supply, installation, and maintenance of advanced medical equipment."
      },

      ///////////////////
      "about": {
        "title": "About MEDENG CO",
        "subtitle": "We prioritize service quality and customer satisfaction.",
        "description": "MEDENG Co, a subsidiary of Al Mansouryah Co., specializes in medical equipment planning, supply, installation, and maintenance. Al Mansouryah is a leading Class \"A\" contractor with over 35 years of experience in turnkey hospital projects across Saudi Arabia and is currently building 354 Primary Health Care Centers for the Ministry of Health.",
        "stats": {
          "agencies": "Agencies",
          "offices": "Offices",
          "projects": "Projects",
          "partners": "Partners"
        }
      },


      ////////////////////////////////////
      "about1": {
        "missionTitle": "Our Mission",
        "missionDescription": "Our mission is to drive national development in the medical and educational fields by delivering cutting-edge biomedical equipment and technology solutions that align with the Kingdom of Saudi Arabia’s strategic plans. We are dedicated to supporting the nation’s Vision 2030 by enhancing healthcare infrastructure, advancing medical capabilities, and empowering healthcare professionals through innovative, reliable, and high-quality biomedical equipment.",
        "visionTitle": "Our Vision",
        "visionDescription": "Our vision is to lead the advancement of our nation’s healthcare system by leveraging our expertise in biomedical equipment and integrating the latest global medical technologies. We are committed to delivering innovative, reliable, and high-quality solutions that elevate patient care, support medical professionals, and drive the future of health technology in the Kingdom."
      },

      ///////////////////
      "carousel": {
        "previous": "‹ Previous",
        "next": "Next ›",
        "alt": "Slide {{number}}"
      },



      ////////////////////////////
      ourPartners: 'Our Partners',
      collaborateWithLeaders: 'We proudly collaborate with industry leaders and innovators',

      //////////////////////////////////////////////
      "Our Clients": "Our Clients",
      "Trusted by top hospitals, research labs, and medical institutions": "Trusted by top hospitals, research labs, and medical institutions",


      //////////////////////////////////
      ceoMessageTitle: "CEO Message",
      ceoMessageContent1: "At our company, our mission is to support the healthcare sector by providing advanced and reliable medical equipment and machines to hospitals, clinics, and healthcare providers. We are committed to supplying cutting-edge technologies that enable medical professionals to deliver safe, efficient, and high-quality care.",
      ceoMessageContent2: "We focus on building long-term partnerships by understanding the unique needs of each client and delivering tailored solutions backed by professional service and technical expertise. Whether it's diagnostic systems, surgical equipment, or patient monitoring machines, we ensure that every product meets international standards for safety, accuracy, and performance.",
      ceoName: "MR. AMER AL-REJAYAE",
      ceoPosition: "Vice Chairman & CEO",




      ////////////////////////////////////////////
      ourTeamTitle: 'Our Team',
      teamMember1: {
        name: 'ENG SAMER SULAIMAN AL-REJAYAE',
        role: 'Member of the Board of Directors',
      },
      teamMember2: {
        name: 'ENG OMER AL-JASSEM',
        role: 'Project Manager',
      },



      ///////////////////////////////////
      "footer": {
        "companyName": "MedEng Co.",
        "companyDescription": "MedEng Co. Ltd — delivering excellence in medical equipment supply and services across the Kingdom of Saudi Arabia.",
        "contact": "Contact",
        "address": "Almansouryah Co , Al-Washam St , Riyadh , Kingdom of Saudi Arabia",
        "phoneLabel": "Tel:",
        "faxLabel": "Fax:",
        "emailLabel": "Email:",
        "followUs": "Follow Us",
        "copyright":
          "© Copyright 2025 — Medeng Co. Ltd"
      },

///////////////////////////////////////EQUIPMENTS////////////////////////////////////////////////
      "our_medical_equipment": "Our Medical Equipment",
      "our_medical_equipment_desc": "We provide a wide range of advanced medical equipment to hospitals and clinics, ensuring reliability, accuracy, and innovation in every product.",
      "unnamed_product": "Unnamed Product",

      "categories": {
        "operation_theater": {
          "title": "Operation Theater",
          "description": "High quality operating room equipment.",
          "products": [
            "Surgical Lights",
            "O.R Table",
            "O.R Lights",

          ]
        },
        "medical_furniture": {
          "title": "Medical Furniture",
          "description": "Ergonomic and durable medical furniture.",
          "products": [

            "Trolley",
            "Blood Sample Couch",
            "Patient Beds",
            "Examination Plinth"
          ]
        },
        "sterilization": {
          "title": "Sterilization",
          "description": "Advanced sterilization tools and systems.",
          "products": [
            "Sterilizers / Autoclaves",
            "Ultrasonic Washer",
            "Large steam sterilizers"

          ]
        },
        "patient_monitoring": {
          "title": "Patient Monitoring",
          "description": "Reliable and precise patient monitoring devices.",
          "products": [
            "CTG",
            "ECG",
            "Patient Monitors & Central Stations"
          ]
        },
        "xray": {
          "title": "X-ray",
          "description": "State-of-the-art X-ray machines.",
          "products": [
            "CT",
            "X-RAY",
            "C-ARM",
            "Mamography"
          ]
        },
        "lab_equipment": {
          "title": "Lab Equipment",
          "description": "Innovative laboratory equipment for professionals.",
          "products": [
            "Water Baths",
            "Centrifuges",
            "Microscopes",
            "Indicator ",
            "Balances",
            "Hot Plate",
            "Incubator"

          ]
        },

        "dental_equipment": {
          "title": "Dental Equipment",
          "description": "Professional-grade dental tools and machines.",
          "products": [
            "Dental Units",
            "Orthodontics and Implantology",
            "Dental Scanner",
            "X-Ray Dental"
          ]
        },
        "surgical_diagnostic": {
          "title": "Surgical & Diagnostic Instruments",
          "description": "Precision instruments for surgery and diagnostics.",
          "products": [
            "Orthopedic Instruments",
            "Titanium Nailing & Implants",

            "Surgical Instruments"
          ]
        },
        "cold_rooms": {
          "title": "Cold Rooms",
          "description": "Temperature-controlled cold storage rooms.",
          "products": [
            "Medical Refrigerators & Freezers",
            "Laboratory Freezers",
            "Mortuary freezers and refrigerators",
          ]
        },
        "emergency_care": {
          "title": "Emergency Care Solution",
          "description": "Critical emergency care systems and kits.",
          "products": [
            "Ventilator",
            "CPR",
            "AMOUL portable defibrillator"
          ]
        },

      },



      ///////////////////////////////////////////////
      "turnkey": {
        "turnkeyEquippingAgency": "Comprehensive solutions for the outfitting of medical facilities",
        "facilityPlanningTitle": "Starting the work of drawing plans according to international standards.",
        "equipmentSetupTitle": "Providing modern and comprehensive medical equipment.",
        "projectManagementTitle": "Prompt completion and delivery of work according to the project's approved plan.",
        "regulatoryComplianceTitle": "Execution of organized and reliable work, licensed by all relevant authorities.",
        "digitalHealthTitle": "Providing advanced digital solutions that connect the hospital with the patient wherever they are.",
        "close": "Close"
      },



      ////////////sales agencies//////////////////
      "title": {
        "ourTrustedAgency": "We have dealt with agencies and manufacturers with extensive experience in manufacturing and producing the latest medical devices and equipment.",
        "whatWeOffer": "What We Offer"
      },
      "topCards": [
        { "id": "patientMonitoring", "title": "OR" },
        { "id": "medicalFurniture", "title": "Medical Furniture" },
        { "id": "sterilizationEquipment", "title": "Sterilization Equipment" },
        { "id": "laboratoryEquipment", "title": "Laboratory Equipment" },

        { "id": "dental", "title": "Dental Equipments" },
        { "id": "emergency", "title": "Emergency Care Solution" },
        { "id": "XRay", "title": "X-Ray" },

      ],
      "modalData": {
        "patientMonitoring": [
          { "agency": "ACENDIS", "country": "Germany", "product": "Patient Monitoring Devices, Vital Signs" },
          { "agency": "EDAN", "country": "China", "product": "CTG, ECG, Central Stations" }
        ],
        "medicalFurniture": [
          { "agency": "SIDHIL", "country": "UK", "product": "Beds, Examination Tables" },
          { "agency": "CFS", "country": "Italy", "product": "Trolleys, Blood Sample Couches" },
          { "agency": "METRO", "country": "USA", "product": "Emergency Trolley" },
          { "agency": "UMF", "country": "USA", "product": "Examination Couch" },
          { "agency": "Godrej", "country": "India", "product": "Office Furniture" }
        ],
        "sterilizationEquipment": [
          { "agency": "Celitron", "country": "Spain", "product": "Steam sterilization units,Sterilization washers" },
          { "agency": "Stanbridge", "country": "UK", "product": "Sterilization consumables" },
          { "agency": "AJ Costa", "country": "Portugal", "product": "Plasma sterilization units" }
        ],

        "laboratoryEquipment": [
          { "agency": "Branson", "country": "Switzerland", "product": "Microscopes, Blood Chemistry Analyzers" },
          { "agency": "evermed", "country": "Italy", "product": "Cooling Refrigerators" },
          { "agency": "LW Scientific", "country": "USA", "product": "Complete Blood Count (CBC) analyzers" }
        ],

        "XRay": [
          { "agency": "idetec", "country": "France", "product": "CT , X-RAY , C-ARM , Memograpghy " },
        ],
        "emergency": [
          { "agency": "Amoul", "country": "China", "product": "CPR , Ventilator " },
        ],
        "dental": [
          { "agency": "Apple Dental", "country": "China", "product": "Dental Units , Dental Scanners , X-RAY Dental " },
          { "agency": "Ritter", "country": "Germany", "product": " Orthodontics & Implantology" },
        ],


      },



      ////////////////////////////////////////
      "featured_projects": "Our Featured Projects",
      "view_gallery": "View Gallery",
      "featured_subtitle": "Explore our portfolio of innovative healthcare facilities designed with precision and advanced technology.",
      "projects": {
        "al_rass": {
          "name": "AL RASS GENERAL HOSPITAL (200 BEDS + HOUSING)",
          "description": "A modern 200-bed healthcare facility with advanced diagnostics and surgical units. Includes staff housing for seamless 24/7 medical support."
        },
        "health_center_354": {
          "name": "354 Health Center For Ministry of Health Nationwide",
          "description": "Nationwide network of health centers offering primary care and emergency services. Strategically located for urban and rural accessibility."
        },
        "king_fahad_dammam": {
          "name": "King Fahad Special Hospital Dammam",
          "description": "Tertiary care center with cutting-edge equipment serving complex surgeries in Eastern Province. Built for sustainability and future growth."
        },
        "king_abdulaziz": {
          "name": "King Abdul‑Aziz Hospital & Special Clinics",
          "description": "Specialized outpatient hospital with advanced labs and imaging. Centrally located to improve regional healthcare access."
        },
        "madinah_maternity": {
          "name": "Madinah Maternity and Pediatric Hospital (500 Beds + Housing)",
          "description": "A 500-bed hospital focusing on maternal and child health with NICU and family-centered care. Includes housing for specialized staff availability."
        },
        "qasim_university": {
          "name": "Al-Qasim University Hospital",
          "description": "Combines medical education with regional healthcare services. Equipped with modern classrooms and patient care units supporting clinical training."
        }
      },

      ////////////////////complete Design/////////////////////////
      "completeDesign": {
        "hero": {
          "title": "Complete Project Design & Engineering"
        },
        "features": {
          "heading": "What MEDENG CO Offers",
          "conceptTitle": "Concept to Commissioning",
          "conceptDesc": "From initial planning to final delivery, MEDENG CO handles every stage with precision, ensuring seamless transition from design to execution in medical engineering.",

        },
        "slider": {
          "heading": "MEDENG CO Project Highlights"
        },
        "why": {
          "heading": "Why MEDENG CO",
          "precision": {
            "title": "Precision",
            "desc": "High accuracy in design & production."
          },
          "innovation": {
            "title": "Innovation",
            "desc": "Leading in biomedical R&D & automation."
          },
          "support": {
            "title": "Support",
            "desc": "24/7 global support for performance."
          }
        },
        "footer": "Complete Project Design & Engineering"
      },





      ////////////OR//////////////////
      "OR": {
        "hero": {
          "title": "Specialized Solutions & Digital Operating Rooms"
        },
        "features": {
          "title": " Digital Operating Room "
        },
        "feature": {
          "orIntegration": {
            "title": "Operating Room Integration",
            "description": "Advanced solutions with an integrated system that includes: surgical lighting, a video transmission system, and an integrated archiving system.",
            "services": [
              "Surgical lights and video integration",
              "Patient data connectivity",

            ]
          },
          "smartPanels": {
            "title": "Smart Control Panels",
            "description": "",
            "services": [
              "Touch interface setup",
              "Custom scene settings",

            ]
          },
          "infectionControl": {
            "title": "Advanced Infection Control Solutions with Sealed Stainless Steel Panels",
            "description": "",
            "services": [
              "UV sterilization units",
              "Air quality monitoring",

            ]
          }

        },

        "footer": "Specialized Solutions & Digital Operating Rooms"
      },
    






      /////////////icu///////////////
      "icu": {


        "servicesTitle": "Included Services",
        "footer": "ICU Pendants",
        "features": {
          "modular": {
            "title": "ICU pendent",

            "services": [
              "Modular Arm Installation",
              "Ergonomic Layout Consulting",
              "Load Capacity Testing"
            ]
          },

        }
      },

      ///////////////////MRI///////////////////////
      "MRI": {
        "sectionTitles": {
          "whyChoose": "MRI - Shielding"
        },

        "footer": {
          "copyright": "MedEng - Advanced MRI Shielding Solutions"
        },
        "modal": {
          "title": "{{title}} - Related Services",
          "description": "Here are the key services related to {{title}}:",
          "close": "Close"
        },
        "features": {
          "rf": {
            "title": "RF (Radio Frequency) Shielding",

            "services": [
              "Faraday Cage Design",
              "Copper Layer Installation",
              "Seam Soldering & Testing",
              "RF Noise Analysis & Mitigation"
            ]
          },

          "design": {
            "title": "Design & Installation",

            "services": [
              "3D CAD Design",
              "Prefabricated Panel Installation",
              "Waveguide Filter Setup",
              "IEC & ISO Certification"
            ]
          }
        },
        "additionalInfo": {
          "performance": {
            "title": "Performance Benchmarks",
            "detail": "RF attenuation up to 120 dB; magnetic fringe below 5 Gauss; rigorous IEC and MIL-STD certification by MedEng specialists."
          },
          "materials": {
            "title": "Certified Materials",
            "detail": "Made from high-quality materials: copper and galvanized steel to ensure superior performance and long-lasting durability."
          },

        }
      },

      ////////////////////Dental//////////////////////
      "dental": {
        "heroTitle": "Advanced Dental Equipment Solutions",
        "featuredEquipment": "Featured Dental Equipment",
        "portfolioTitle": "Our Dental Equipment Portfolio",
        "keyFeatures": "Key Features & Services:",
        "footer": "Dental Equipment Division",
        "equipment": {
          "chair": {
            "title": "Dental Chair Units",
            "description": "Ergonomically designed units with customizable settings, integrated instrument trays, and advanced foot controls to maximize comfort and efficiency.",
            "image": "354_health_center_1.jpeg",
            "details": [
              "Adjustable headrest and backrest for patient comfort",
              "Integrated LED operating light",
              "Built-in instrument trays with modular options",
              "Foot control with programmable presets"
            ]
          },
          "imaging": {
            "title": "Digital Imaging Systems",
            "description": "High-resolution intraoral cameras and panoramic X-ray machines for precise diagnostics and real-time treatment monitoring.",
            "image": "SE8.jpg",
            "details": [
              "Panoramic and cephalometric imaging",
              "Digital sensor technology with low radiation",
              "Real-time image processing and enhancement",
              "Integrated patient education software"
            ]
          },
          "sterilization": {
            "title": "Sterilization Equipment",
            "description": "Autoclaves and sterilizers designed to meet the highest hygiene standards for infection control.",
            "image": "sterilization.jpeg",
            "details": [
              "Fast-cycle autoclaves with digital controls",
              "Chemical indicators and validation systems",
              "Space-efficient sterilization cabinets",
              "Compliance with international safety standards"
            ]
          },
          "suctionLighting": {
            "title": "Suction & Lighting Systems",
            "description": "Quiet, efficient vacuum pumps paired with shadow-free LED surgical lighting for optimal operatory conditions.",
            "image": "suction_lighting.jpg",
            "details": [
              "High-performance suction pumps",
              "Adjustable color temperature LED lights",
              "Energy-efficient and low maintenance",
              "Sterile field compliance design"
            ]
          },

          "scalers": {
            "title": "Ultrasonic Scalers",
            "description": "Powerful and ergonomic scalers for efficient plaque and tartar removal with adjustable frequency modes.",
            "image": "scalers.jpg",
            "details": [
              "Multiple power and frequency settings",
              "Lightweight and balanced handpiece",
              "LED illumination tip options",
              "Compatible with various tip designs"
            ]
          },

          "lab": {
            "title": "Dental Lab Equipment",
            "description": "Comprehensive lab tools including mixers, ovens, and model trimmers for precise prosthetics manufacturing.",
            "image": "lab_equipment.jpg",
            "details": [
              "Efficient model trimmers with dust extraction",
              "Digital wax mixers",
              "High-temperature curing ovens",
              "Ergonomic and safety-certified equipment"
            ]
          }
        }
      },
      "common": {
        "close": "Close"
      }

    },
  },





  ar: {
    translation: {

      "nav": {
        "home": "الـــرئيسيـــة",
        "equipments": "الـــمعدات",
        "solutions": "الـــحلـــول",
        "solutions.mri": "تـــدريـع الـتصويـــر بالرنين الـمغنـاطيـــسي",
        "solutions.dental": "الأسنان",
        "solutions.specialized": "حلـــول متـــخصصـــة",
        "solutions.design": "تـــصميـــم الـــمشروع الـــكامل",
        "solutions.networking": "شبكـــات الـــمستـــشفيـــات",
        "solutions.icu": "وحدات التغذيـــة السقفـــية (pendant)",
        "business": "أعمالنـــا",
        "business.turnkey": "تـــــــجهيـــــــز متـــــــكامل",
        "business.agency": "تـــوريـــــــداتــــنـــــــا ",
        "business.construction": "بناء المستشفيات",
        "projects": "الـــمشاريـــع"
      },
      ///////////////////////////////////
      "hero": {
        "heading": "إبـــداع فـــي الـــهندسة وارتقـــاء بالـــرعايـــة الصـــحيـــة",
        "subheading": "نحن متخصصون في توريد وتركيب وصيانة المعدات الطبية المتقدمة."
      },

      ////////////About///////////////
      "about": {
        "title": "  نبذه عن شركة الهندسة الطبية",
        "subtitle": "نحن شركة الهندسة الطبية نولي أهمية قصوى لجودة الخدمة ورضا العملاء",
        "description": "نحن نتخصص بتقديم خدمة التخطيط للمنشات الطبية وتوريد وتركيب وصيانة المعدات الطبية كفرع من شركة  المنصورية للمقاولات العامة التي تعتبر مقاول من الدرجة الاولى مع خبرة تزيد عن ٥٠ سنة في تقديم مشاريع عملاقة ومتكاملة كمنشآت طبية وغير طبية .",
        "stats": {
          "agencies": "الوكالات",
          "offices": "المكاتب",
          "projects": "المشاريع",
          "partners": "الشركاء"
        }
      },
      
      ///////////////Vision & Mission/////////////////////////
      "about1": {
        "missionTitle": "مهمتنا",
        "missionDescription": "مهمتنا هي دفع عجلة التنمية الوطنية في المجالات الطبية والتعليمية من خلال تقديم معدات وتقنيات حيوية متطورة تتماشى مع الخطط الاستراتيجية للمملكة العربية السعودية. نحن ملتزمون بدعم رؤية المملكة 2030 من خلال تعزيز البنية التحتية للرعاية الصحية، وتطوير القدرات الطبية، وتمكين الكوادر الصحية عبر حلول مبتكرة وموثوقة وعالية الجودة.",
        "visionTitle": "رؤيتنا",
        "visionDescription": "رؤيتنا هي المشاركه في قيادة تطوير النظام الصحي الوطني من خلال الاستفادة من خبراتنا في مجال المعدات الطبية الحيوية وتطبيق أحدث التقنيات الطبية العالمية. نحن ملتزمون بتقديم حلول مبتكرة وموثوقة وعالية الجودة تسهم في رفع جودة الرعاية الصحية، ودعم العاملين في القطاع الصحي، ودفع عجلة مستقبل التكنولوجيا الصحية في المملكة."
      },

      /////////////////////////////////////
      "carousel": {
        "previous": "‹ السابق",
        "next": "التالي ›",
        "alt": "الشريحة {{number}}"
      },

      /////////////////////////////////////////
      ourPartners: 'شركاؤنا',
      collaborateWithLeaders: 'نفخر بالتعاون مع قادة الصناعة والمبتكرين',

      ////////////////////////////////////////////
      "Our Clients": "عملاؤنا",
      "Trusted by top hospitals, research labs, and medical institutions": "موثوق به من قبل أفضل المستشفيات والمعامل البحثية والمؤسسات الطبية",
      ///////////////////////////////////////

      ceoMessageTitle: "رسالة الرئيس التنفيذي",
      ceoMessageContent1: "في شركتنا، نلتزم بدعم قطاع الرعاية الصحية من خلال توفير معدات وأجهزة طبية متقدمة وموثوقة للمستشفيات والعيادات ومقدمي خدمات الرعاية الصحية. نحن نسعى جاهدين لتقديم أحدث التقنيات التي تمكّن المهنيين الطبيين من تقديم رعاية آمنة وفعالة وعالية الجودة.",
      ceoMessageContent2: "نركّز على بناء شراكات طويلة الأمد من خلال فهم الاحتياجات الفريدة لكل عميل وتقديم حلول مخصصة مدعومة بخدمة احترافية وخبرة فنية. سواء كانت أنظمة تشخيصية أو معدات جراحية أو أجهزة مراقبة المرضى، نضمن أن كل منتج يفي بالمعايير الدولية من حيث السلامة والدقة والأداء.",
      ceoName: "الأستاذ عــامر الــرجيــعي",
      ceoPosition: "الرئيس التنفيذي",


      ///////////////////////
      ourTeamTitle: 'فريقنا',
      teamMember1: {
        name: 'م. سامر سليمان الــرجيــعي',
        role: 'عضو مجلس الإدارة',
      },
      teamMember2: {
        name: 'م. عمر الجاسم',
        role: 'مدير المشاريع',
      },

      ///////////////////////////////////
      "footer": {
        "companyName": "شركة الهندسة الطبية",
        "companyDescription": "شركة الهندسة الطبية — نقدم التميز في توريد المعدات الطبية والخدمات في جميع أنحاء المملكة العربية السعودية.",
        "contact": "تواصل معنا",
        "address": "  شركة المنصورية - شارع الوشم - الرياض - المملكة العربية السعودية",
        "phoneLabel": "الهاتف:",
        "faxLabel": "الفاكس:",
        "emailLabel": "البريد الإلكتروني:",
        "followUs": "تابعنا على",
        "copyright":
          "© جميع الحقوق محفوظة 2025 — شركة الهندسة الطبية"
      },


      ////////////////////////////////////////////////////

      "our_medical_equipment": "معداتنا الطبية",
      "our_medical_equipment_desc": "نحرص على تقديم حلول متكاملة تجمع بين الجودة و الخدمة المتميزة",
      "unnamed_product": "منتج بدون اسم",

      "categories": {
        "operation_theater": {
          "title": "غرف العمليات",
          "description": "معدات غرفة عمليات عالية الجودة.",
          "products": [
            "لمبات عمليات حديثة",
            "طاولة العمليات",

            "اضواء غرفة العمليات ",

          ]
        },
        "medical_furniture": {
          "title": "الأثاث الطبي",
          "description": "اثاث طبي وفق اعلي معايير الجودة و المتانة ",
          "products": [

            "عربة",
            "كرسي سحب عينات الدم",
            "أسرة المرضى",
            "طاولة الفحص"
          ]
        },
        "sterilization": {
          "title": "التعقيم المركزي",
          "description": "أدوات ونظم تعقيم متقدمة.",
          "products": [
            "  اجهزة التعقيم المركزي      ",
            "غسالة بالموجات فوق الصوتية",
            "معقمات بالبخار كبيرة الحجم",

          ]
        },
        "patient_monitoring": {
          "title": "مراقبة المرضى",
          "description": "أجهزة مراقبة دقيقة وموثوقة للمرضى.",
          "products": [
            "جهاز مراقبة الجنين (CTG)",
            "جهاز تخطيط القلب (ECG)",
            "شاشات مراقبة المرضى و وحدات المراقبة المركزية"
          ]
        },
        "xray": {
          "title": "الأشعة السينية",
          "description": "أحدث أجهزة الأشعة السينية.",
          "products": [
            "الأشعة المقطعية",
            "X-RAY",
            "جهاز التصوير بالأشعة السينية المتحرك (سي آرم)",
            "التصوير الشعاعي للثدي"
          ]
        },
        "lab_equipment": {
          "title": "معدات المختبر",
          "description": "أجهزة مختبرات متقدمة بمختلف انواعها",
          "products": [
            "حمامات مائية",
            "أجهزة الطرد المركزي",
            "الميكروسكوبات",
            "مؤشِّر  ",
            "موازين",
            "صفيحة تسخين",
            "جهاز الحاضنة"
          ]
        },

        "dental_equipment": {
          "title": "معدات الأسنان",
          "description": "تجهيز عيادات اسنان حديثة ومتكاملة",
          "products": [
            "وحدات الأسنان",
            "تقويم وزراعة الأسنان",
            "ماسح الأسنان",
            " الأشعة السينية للأسنان",
          ]
        },
        "surgical_diagnostic": {
          "title": "الأدوات الجراحية والتشخيصية",
          "description": "أدوات جراحية لمختلف التخصصات",
          "products": [
            "أدوات جراحة العظام",
            "المسامير والتيتانيوم والزرعات",
            "مناظير الحنجرة",
            "مجموعة التشخيص",
            "الأدوات الجراحية"
          ]
        },
        "cold_rooms": {
          "title": "غرفة التبريد و المشرحة  ",
          "description": "تجهيز غرف تبريد محكمة ومتخصصة",
          "products": [
            "ثلاجات ومجمدات طبية",
            " مجمدات المختبر",
            "الثلاجات والمجمدات الطبية للمشارح"
          ]
        },
        "emergency_care": {
          "title": "حلول الطوارئ",
          "description": "انظمة و حلول رعاية الطوارئ الحرجة ",
          "products": [
            "مروحة",
            "جهاز الإنعاش القلبي الرئوي",
            "جهاز صدمات محمول AMOUL"
          ]
        },

      },

      ////////////////////////////

      "turnkey": {
        "turnkeyEquippingAgency": "حلول متكاملة في أعمال التجهيز للمنشآت الطبية",
        "facilityPlanningTitle": "بدءا باعمال رسم المخططات حسب المعايير الدولية",


        "equipmentSetupTitle": "توفير معدات طبية حديثة ومتكاملة",

        "projectManagementTitle": "سرعة في الإنجاز وتسليم الأعمال حسب المخطط المرسوم للمشروع",

        "regulatoryComplianceTitle": "تنفيذ اعمال  منظمة وموثوقة ومرخصة من جميع جهات الاختصاص",

        "digitalHealthTitle": "تقديم الحلول الرقمية المتقدمة التي تربط بين المستشفى والمريض أينما كان",

        "close": "إغلاق"
      },

      //////////////////////////////////////////
      "title": {
        "ourTrustedAgency": "تعاملنا مع وكالات ومصنعين ذوي خبرات طويلة في التصنيع والإنتاج لاحدث الأجهزة والمعدات الطبية",

        "whatWeOffer": "ماذا نقدم"
      },
      "topCards": [
        { "id": "patientMonitoring", "title": "العمليات " },
        { "id": "medicalFurniture", "title": "الأثاث الطبي" },
        { "id": "sterilizationEquipment", "title": "معدات التعقيم" },
        { "id": "laboratoryEquipment", "title": "معدات المختبر" },

        { "id": "dental", "title": "معدات الأسنان" },
        { "id": "emergency", "title": "حلول الطوارئ" },
        { "id": "XRay", "title": "الأشعة السينية" },



      ],
      "modalData": {
        "patientMonitoring": [
          { "agency": "ACENDIS", "country": "ألمانيا", "product": "أجهزة مراقبة المرضى، العلامات الحيوية" },
          { "agency": "EDAN", "country": " الصين", "product": "CTG, ECG, المحطات المركزية" }
        ],
        "medicalFurniture": [
          { "agency": "SIDHIL", "country": "المملكة المتحدة", "product": "أسرة، طاولات الفحص" },
          { "agency": "CFS", "country": "إيطاليا", "product": "عربات، أريكة عينات الدم" },
          { "agency": "METRO", "country": "الولايات المتحدة", "product": "عربة الطوارئ" },
          { "agency": "UMF", "country": "الولايات المتحدة", "product": "أريكة الفحص" },
          { "agency": "Godrej", "country": "الهند", "product": "أثاث المكتب" }
        ],
        "sterilizationEquipment": [
          { "agency": "Celitron", "country": "إسبانيا", "product": " وحدات التعقيم بالبخار , غسالات التعقيم " },
          { "agency": "Stanbridge", "country": "المملكة المتحدة", "product": " مستهلكات التعقيم" }, //NEW
          { "agency": "AJ Costa", "country": "البرتغال", "product": "  وحدات التعقيم بالبلازما" }
        ],

        "laboratoryEquipment": [
          { "agency": "Branson", "country": "سويسرا", "product": "مجاهر،  اجهزة كيمياء الدم " },
          { "agency": "evermed", "country": "إيطاليا", "product": " ثلاجات التبريد" },//NEW
          { "agency": "LW Scientific", "country": "الولايات المتحدة", "product": " اجهزة صورة الدم (CBC) " }
        ],

        "XRay": [
          { "agency": "idetec", "country": "فرنسا", "product": "الأشعة المقطعية  , X-RAY ,  التصوير الشعاعي للثدي " },
        ],

        "emergency": [
          { "agency": "Amoul", "country": "الصين", "product": "مروحة , جهاز الإنعاش القلبي الرئوي " },
        ],

        "dental": [
          { "agency": "Apple Dental", "country": "الصين", "product": "وحدات الأسنان , ماسح الأسنان , الأشعة السينية للأسنان " },
          { "agency": "Ritter", "country": "ألمانيا", "product": " تقويم وزراعة الأسنان" },
        ],




      },

      //////////////////////////////////////
      "featured_projects": "مشاريعنا المميزة",
      "featured_subtitle": "استعرض مجموعة مشاريعنا في مجال الرعاية الصحية المصممة بعناية وبتقنيات متقدمة.",
      "view_gallery": "عرض المعرض",
      "projects": {
        "al_rass": {
          "name": "مستشفى الرس العام (200 سرير + سكن)",
          "description": "منشأة رعاية صحية حديثة بسعة 200 سرير مع وحدات تشخيصية وجراحية متقدمة. يشمل سكن للطاقم الطبي لضمان الدعم على مدار الساعة."
        },
        "health_center_354": {
          "name": "354 مركز صحي لوزارة الصحة في جميع أنحاء المملكة",
          "description": "شبكة وطنية من المراكز الصحية تقدم خدمات الرعاية الأولية والطوارئ. تقع بشكل استراتيجي لتخدم المناطق الحضرية والريفية."
        },
        "king_fahad_dammam": {
          "name": " مستشفى الملك فهد التخصصي بالدمام (650) سرير",
          "description": "  مستشفي بسعة 650 سرير مزود بأحدث المعدات لإجراء العمليات الجراحية المعقدة في المنطقة الشرقية. تم بناؤه ليكون مستدامًا وقابلًا للتوسع."
        },
        "king_abdulaziz": {
          "name": "مستشفى وعيادات الملك عبدالعزيز الخاصة",
          "description": "        عيادات خارجية متخصصة تحتوي علي احدث الاجهزة للمختبرات الطبية و التصوير الرقمي . يقع في موقع مركزي لتحسين الوصول إلى الرعاية الصحية."
        },
        "madinah_maternity": {
          "name": "مستشفى المدينة للولادة والأطفال (500 سرير + سكن)",
          "description": "مستشفى بسعة 500 سرير يركز على صحة الأم والطفل ويحتوي على وحدة عناية مركزة لحديثي الولادة ورعاية عائلية. يشمل سكن للطاقم الطبي المتخصص."
        },
        "qasim_university": {
          "name": "مستشفى جامعة القصيم",
          "description": "يجمع بين التعليم الطبي والخدمات الصحية الإقليمية. مزود بفصول دراسية حديثة ووحدات رعاية تدعم التدريب السريري."
        }
      },

      ////////////////////////////////////////
      "completeDesign": {
        "hero": {
          "title": "تصميم وهندسة المشاريع الكاملة"
        },
        "features": {
          "heading": "ما الذي تقدمه شركة الهندسة الطبية؟",
          "conceptTitle": "من الفكرة إلى التشغيل",
          "conceptDesc": "من التخطيط الأولي إلى التسليم النهائي، تتولى شركة الهندسة الطبية كل مرحلة بدقة، لضمان انتقال سلس من التصميم. إلى الإنشاء حتى توريد الأجهزة الطبية كمنظومة متكاملة لكل الأقسام.",

        },
        "slider": {
          "heading": "أبرز مشاريع شركة الهندسة الطبية"
        },
        "why": {
          "heading": "لماذا شركة الهندسة الطبية؟",
          "precision": {
            "title": "الدقة",
            "desc": "الدقة في التسليم بالمواعيد المحددة"
          },
          "innovation": {
            "title": "تزويد المعدات الطبية",
            "desc": "تقديم احدث الابتكارات وكل ما هو جديد في مجال الأجهزة الطبية"
          },
          "support": {
            "title": "الدعم",
            "desc": "تقديم خدمة الدعم الفني على مدار الساعة"
          }
        },

        "footer": "تصميم وهندسة المشاريع الكاملة"
      },
      ///////////////////////////////

      "OR": {
        "hero": {
          "title": "الحلول المتخصصة وغرف العمليات الرقمية"
        },
        "features": {
          "title": " غرف العمليات الرقمية "
        },
        "feature": {
          "orIntegration": {
            "title": "غرف عمليات متكاملة",
            "description": "حلول متطورة بنظام متكامل مدمج يشمل: الإضاءة الجراحية - نظام نقل الفيديو مع نظام الأرشفة المتكامل .",
            "services": [
              "إتصال مباشر يضمن نقل بيانات دقيقة و أرشفتها .",
              "بث الفيديو المباشر إلى نظام PACS للتوثيق والمراجعة الفورية.",

            ]
          },
          "smartPanels": {
            "title": "لوحات عرض تحكم ذكية",
            "description": "",
            "services": [
              "تحكم باللمس لمحتويات غرفة العمليات",
              "عرض معلومات هامة (الضغط-الحرارة-الرطوبة) في غرفة العمليات والتحكم بها",

            ]
          },
          "infectionControl": {
            "title": "أنظمة مكافحة العدوى",
            "description": "",
            "services": [
              "وحدات التعقيم بالأشعة فوق البنفسجية",
              "تركيب فلاتر الهواء ذات الترشيح العالي للبكتيريا Hepa Filter.",

            ]
          }
        },

        "footer": "الحلول المتخصصة وغرف العمليات الرقمية"
      },




      ////////////////////////////////
      "icu": {
        "servicesTitle": "الخدمات ",
        "footer": "أجهزة تعليق العناية المركزة",
        "features": {
          "modular": {
            "title": "(وحدات التغذية السقفية) pendant",

            "services": [
              "توفير توصيلات متعددة لجميع أنواع الغازات الطبية.",
              "توفير مصدر كهرباء متعدد.",
              "قابلة للتحكم في الإرتفاع والحركة ."
            ]
          },

        }
      },



      ///////////////////////////////////////
      "MRI": {
        "sectionTitles": {
          "whyChoose": "تدريع جهاز الرنين المغناطيسي"
        },

        "footer": {
          "copyright": "MedEng - حلول حماية متقدمة لأجهزة الرنين المغناطيسي"
        },
        "modal": {
          "title": "{{title}} - الخدمات ذات الصلة",
          "description": "فيما يلي الخدمات الأساسية المتعلقة بـ {{title}}:",
          "close": "إغلاق"
        },
        "features": {
          "rf": {
            "title": "الحماية من ترددات الراديو (RF)",

            "services": [
              "تصميم قفص فاراداي",
              "تركيب طبقة نحاسية",
              "اختبار ولحام الوصلات",
              "تحليل وتقليل ضوضاء RF"
            ]
          },

          "design": {
            "title": "التصميم والتركيب",

            "services": [
              "تصميم ثلاثي الأبعاد CAD",
              "تركيب الألواح الجاهزة",
              "إعداد مرشحات الموجات",
              "شهادات IEC و ISO"
            ]
          }
        },
        "additionalInfo": {
          "performance": {
            "title": "معايير الأداء",
            "detail": "توهين ترددات الراديو حتى 120 ديسيبل؛ تقليل المجال المغناطيسي المنتشر لأقل من 5 جاوس؛ شهادات معتمدة وفقًا لمعايير IEC وMIL-STD من قبل مختصي MedEng."
          },
          "materials": {

            "title": "مواد معتمدة",
            "detail": "مصنوع من خامات عالية الجودة: النحاس والفولاذ المجلفن لضمان أداء متفوق ومتانة طويلة الأمد."


          },

        }
      },



      //////////////////////////////
      "dental": {
        "heroTitle": "حلول متقدمة لمعدات طب الأسنان",
        "featuredEquipment": "المعدات المميزة",
        "portfolioTitle": "تجهيز عيادات الاسنان",
        "keyFeatures": "الميزات والخدمات الرئيسية:",
        "footer": "قسم معدات طب الأسنان",
        "equipment": {
          "chair": {
            "title": "وحدات كراسي الأسنان",
            "description": "وحدات مصممة بشكل مريح مع إعدادات قابلة للتخصيص، وصواني أدوات مدمجة، وتحكم متقدم بالأقدام لتعزيز الراحة والكفاءة.",
            "image": "354_health_center_1.jpeg",
            "details": [
              "مسند رأس وظهر قابل للتعديل لراحة المريض",
              "ضوء تشغيل LED مدمج",
              "صواني أدوات مدمجة بخيارات معيارية",
              "تحكم بالقدم مع إعدادات مسبقة قابلة للبرمجة"
            ]
          },
          "imaging": {
            "title": "أنظمة التصوير الرقمي",
            "description": "كاميرات داخل الفم عالية الدقة وأجهزة أشعة بانورامية لتشخيص دقيق ومراقبة فورية للعلاج.",
            "image": "SE8.jpg",
            "details": [
              "تصوير بانورامي وسيفالومتري",
              "تقنية مستشعر رقمي بإشعاع منخفض",
              "معالجة وتحسين الصور في الوقت الفعلي",
              "برامج تعليمية متكاملة للمرضى"
            ]
          },
          "sterilization": {
            "title": "معدات تعقيم الادوات الجراحية في قسم الاسنان  ",
            "description": "أوتوكلافات وأجهزة تعقيم مصممة لتلبية أعلى معايير النظافة ومكافحة العدوى.",
            "image": "sterilization.jpeg",
            "details": [
              "أوتوكلافات سريعة الدورة بتحكم رقمي",
              "مؤشرات كيميائية وأنظمة تحقق",
              "خزائن تعقيم موفرة للمساحة",
              "مطابقة للمعايير الدولية للسلامة"
            ]
          },
          "suctionLighting": {
            "title": "كل ما تحتاجه عيادة الاسنان",
            "description": "مضخات فراغ هادئة وفعالة مقترنة بإضاءة LED جراحية خالية من الظلال لظروف تشغيل مثالية.",
            "image": "suction_lighting.jpg",
            "details": [
              "مضخات شفط عالية الأداء",
              "إضاءة LED بدرجة حرارة لون قابلة للتعديل",
              "موفرة للطاقة وقليلة الصيانة",
              "تصميم متوافق مع الحقل المعقم"
            ]
          },

          "scalers": {
            "title": "أجهزة التنظيف بالموجات فوق الصوتية",
            "description": "أجهزة تنظيف قوية ومريحة لإزالة الجير والبلاك بكفاءة مع أوضاع تردد قابلة للتعديل.",
            "image": "scalers.jpg",
            "details": [
              "إعدادات طاقة وتردد متعددة",
              "مقبض خفيف الوزن ومتوازن",
              "خيارات طرف مضيء بـ LED",
              "متوافق مع تصميمات رؤوس متعددة"
            ]
          },

          "lab": {
            "title": "معدات مختبر الأسنان",
            "description": "مجموعة شاملة من أدوات المختبر بما في ذلك الخلاطات والأفران وأجهزة تشكيل النماذج لصناعة الأطراف بدقة.",
            "image": "lab_equipment.jpg",
            "details": [
              "أجهزة تشكيل النماذج مزودة باستخلاص الغبار",
              "خلاطات شمع رقمية",
              "أفران معالجة بدرجة حرارة عالية",
              "معدات مريحة وآمنة ومعتمدة"
            ]
          }
        }
      },
      "common": {
        "close": "إغلاق"
      }











    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
